import styled from 'styled-components/macro';

const $Menu = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export default $Menu;
